import { PowerMeterModel } from '../models'
import { SettingsFormValues } from '../types'

export const modelToForm = (model?: PowerMeterModel): SettingsFormValues => ({
  deviceName: model?.deviceName ?? '',
  balancedPhases: model?.balancedPhases || [false, false, false],
  phaseElimination: model?.phaseElimination || [false, false, false],
})
